import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">站内快讯 · 实时掌握</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updatesData.map((item, idx) => (
              <div key={item.id} className={`relative mb-6 ${idx === updatesData.length - 1 ? 'mb-0' : ''}`}>
                <div className="absolute -left-[calc(0.5rem+5px)] top-1 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded text-xs font-medium w-fit whitespace-nowrap">
                    {item.tag}
                  </span>
                  <p className="text-sm text-foreground-700">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}